/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pipelines_Board_Zoom_InInputs */

const cs_pipelines_board_zoom_in = /** @type {(inputs: Pipelines_Board_Zoom_InInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Přiblížit`)
};

const en_pipelines_board_zoom_in = /** @type {(inputs: Pipelines_Board_Zoom_InInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zoom in`)
};

/**
* | output |
* | --- |
* | "Zoom in" |
*
* @param {Pipelines_Board_Zoom_InInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const pipelines_board_zoom_in = /** @type {((inputs?: Pipelines_Board_Zoom_InInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pipelines_Board_Zoom_InInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pipelines_board_zoom_in(inputs)
	return cs_pipelines_board_zoom_in(inputs)
});